/**
 * @file Homepage Three Cols
 */

import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

/**
 * Homepage Three Cols component
 */
const vHpThreeCols = () => {
	const hpThreeCols = document.querySelector('.v-hp-three-cols');

	if (!hpThreeCols) {
		return;
	}

	const graphic = hpThreeCols.querySelector('.v-hp-three-cols__column-graphic');

	if (!graphic) {
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	// const barFill = graphic.querySelector('.v-hp-three-cols__bar-fill');

	ScrollTrigger.create({
		trigger: graphic,
		start:   'bottom bottom',
		onEnter: () => {
			graphic.classList.add('v-hp-three-cols__column-graphic--filled');
		},
		onLeaveBack: () => {
			graphic.classList.remove('v-hp-three-cols__column-graphic--filled');
		},
	});
};

export default vHpThreeCols;
